import React, { useState, useEffect, useRef } from 'react';

import './Forms.css';
// import parse from 'html-react-parser';

import Swal from 'sweetalert2'

import * as Hosts from '../../../Hosts';
import {
    reqGET,
    reqPOST,
    reqDELETE
} from '../../../Utils';

import { language } from '../WEBContent/Language';

const RequestUnsubscribeForm = () => {

    const [, set_dados] = useState(null)
    const dados_config = useRef(null)

    const [lang, ] = useState('pt');
    
    const [email_request, set_email_request] = useState(''); 

    useEffect(() => { 

        (async () => {

            let res = await reqGET(`${Hosts.SIMCore_API}/web/config/attributes/type/${Hosts.companycode}/nl_settings`)
            if(res.data.length > 0) {
                set_dados(dados_config.current = res.data[0])
            }

        })()

    }, []); 

    const handleSubmit = async e => {
        e.preventDefault();

        if(email_request === '') {

            Swal.fire(language[lang].nl_unsubscribe_error, language[lang].nl_unsubscribe_error_msg + '' + Hosts.contactFrom, 'error')

        }
        else {

            // ROTAS PARA UNSUBSCRIBE
            let res = await reqGET(`${Hosts.SIMCore_API}/web/nl/log/entity/email/${Hosts.companycode}/${email_request}`)
            if(res !== undefined && res.length > 0 && res[0] !== undefined && res[0] !== null) {

                let today_nl = new Date();

                let nl_unsubscribe = {
                    id: '',
                    info: {
                        companycode: Hosts.companycode,
                        date: today_nl,
                        entity: {
                            id: res.data[0].info.entity.id,
                            uniqid: res.data[0].info.entity.uniqid,
                            email: res.data[0].info.entity.email,
                            name: email_request,
                        },
                        state: 0
                    }
                }

                let aux_unsubscribe_entity = await reqGET(`${Hosts.SIMCore_API}/web/nl/unsubscribe/email/${Hosts.companycode}/${email_request}`)
                if(aux_unsubscribe_entity !== undefined && aux_unsubscribe_entity.length > 0 && aux_unsubscribe_entity.length === 0) {
                    await reqPOST(`${Hosts.SIMCore_API}/web/nl/unsubscribe/${Hosts.companycode}/entity`, nl_unsubscribe)
                }

                await reqDELETE(`${Hosts.SIMCore_API}/web/nl/unsubscribe/${Hosts.companycode}/entity/forget`, nl_unsubscribe)
            
            }
            else {
                
                let today_nl = new Date();

                let nl_unsubscribe = {
                    id: '',
                    info: {
                        companycode: Hosts.companycode,
                        date: today_nl,
                        entity: {
                            email: email_request,
                        },
                        state: 0
                    }
                }

                let aux_unsubscribe_entity = await reqGET(`${Hosts.SIMCore_API}/web/nl/unsubscribe/email/${Hosts.companycode}/${email_request}`)
                if(aux_unsubscribe_entity !== undefined && aux_unsubscribe_entity.length > 0 && aux_unsubscribe_entity.length === 0) {
                    await reqPOST(`${Hosts.SIMCore_API}/web/nl/unsubscribe/${Hosts.companycode}/entity`, nl_unsubscribe)
                }
                await reqDELETE(`${Hosts.SIMCore_API}/web/nl/unsubscribe/${Hosts.companycode}/entity/forget`, nl_unsubscribe)
            
            }

            Swal.fire(language[lang].nl_unsubscribe_success, language[lang].nl_unsubscribe_success_msg + '<br />' + dados_config.current.info.settings.comercial_name, 'success')

        }
    }
        
    return(
        <div>
            <section id="unsubscribe" className="pb-5">

                <div className="container">
                    <div className='row'>
                        <div className='col-12 my-5'>
                            <form onSubmit={handleSubmit}>

                                <div className='row'>
                                    <div className='col-8 col-sm-6 mx-auto py-3 px-4 mb-4 bg-primary text-white text-center text-uppercase'>
                                        {language[lang].contact_unsubscribe}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-8 col-sm-6 mx-auto border py-4 px-4">
                                        <p className='mb-5'>
                                             {language[lang].contact_unsubscribe_msg}
                                        </p>
                                        <label>{language[lang].email}*</label>
                                        <input type="email" name="email" value={email_request} className="form-control rounded-0" placeholder={language[lang].email_placeholder} onChange={(e) => set_email_request(e.target.value)} required />

                                        <div className="text-right">
                                            <button className="mt-5 mx-auto btn btn-primary">{language[lang].send}</button>     
                                        </div>    
                                    </div>
                                </div>   

                                {
                                dados_config?.current?.info?.settings !== undefined ?
                                    <div className='row'>
                                        <div className='col-8 col-sm-6 mx-auto py-3 px-4 mt-4 bg-color-gray-light text-center'>
                                            <p className='mb-0'><strong>{dados_config.current.info.settings.comercial_name}</strong></p>
                                            {/*
                                            <p>
                                                {nl2br(dados_config.current.info.settings.address)}
                                            </p>
                                            <p>
                                                {
                                                dados_config.current.info.settings.tlf !== '' ?
                                                    <span>Tlf: {dados_config.current.info.settings.tlf} </span>
                                                :
                                                    null
                                                }
                                                {
                                                dados_config.current.info.settings.tlm !== '' ?
                                                    <span>Tlm: {dados_config.current.info.settings.tlm} </span>
                                                :
                                                    null
                                                }
                                                {
                                                dados_config.current.info.settings.email !== '' ?
                                                    <span>Email: <a href={'mailto:' + dados_config.current.info.settings.email}>{dados_config.current.info.settings.email}</a> </span>
                                                :
                                                    null
                                                }
                                            </p>
                                            <p>
                                                <a href={dados_config.current.info.settings.link} alt="" title="">{dados_config.current.info.settings.link}</a>
                                            </p>
                                            */}
                                        </div>
                                    </div>
                                :
                                    null
                                }

                                {/*
                                <Footer pag_welcome={true} dados_config={dados_config.current} dados_navbar={{ info: { header: { info: { tag: 'page-10' }}}}} />                 
                                */}

                            </form>
                        </div>
                    </div>
                </div>

            </section>
        </div>
    );


};

export default RequestUnsubscribeForm;